// extracted by extract-css-chunks-webpack-plugin
module.exports = {"button":"button_1mdgC","button_active":"button_active_3gl2s","button_inverted":"button_inverted_3b2vK"};